export default __webpack_public_path__ + "static/media/logo-lightmode.bf54483b.svg";